import { useState, useEffect } from 'react'

export const useFetchAllLocations = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataLocations, setDataLocations] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllLocations, setLoadingFetchAllLocations ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/legal/fetch-all-locations`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllLocations(true)
        fetchData()
            .then((resp) => {
                setDataLocations(resp.rows)
                setLoadingFetchAllLocations(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllLocations(false)
            })
    }, [execute])

    return { dataLocations, loadingFetchAllLocations, executeFetch }

}

export const useFetchSpecificLocation = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificLocation, setLoadingFetchSpecificLocation ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idlocation: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-location/${paramsToSearch.idlocation}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idlocation > 0 ){
            setLoadingFetchSpecificLocation(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idlocation: rows[0].idlocation || '',
                        location_name: rows[0].location_name || ''
                    }))
                    setLoadingFetchSpecificLocation(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificLocation(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificLocation, setParamsToSearch, executeFetch }

}